const STORAGE_PREFIX = "dsa5_help_manual"

export function storageKey(manual, suffix) {
  return `${STORAGE_PREFIX}_${manual}_${suffix}`
}

export function readBoolean(storage, key, fallback = false) {
  try {
    const value = storage.getItem(key)
    if (value === null) return fallback
    return value === "true"
  } catch {
    return fallback
  }
}

export function writeBoolean(storage, key, value) {
  try {
    storage.setItem(key, value ? "true" : "false")
  } catch {
    // localStorage might be unavailable
  }
}

export function readSection(storage, manual, fallback = null) {
  try {
    return storage.getItem(storageKey(manual, "section")) || fallback
  } catch {
    return fallback
  }
}

export function writeSection(storage, manual, sectionId) {
  try {
    storage.setItem(storageKey(manual, "section"), sectionId)
  } catch {
    // localStorage might be unavailable
  }
}

export function useHelpManualState(manual, storage = localStorage) {
  function isOpen() {
    return readBoolean(storage, storageKey(manual, "open"))
  }

  function setOpen(value) {
    writeBoolean(storage, storageKey(manual, "open"), value)
  }

  function activeSection(fallback) {
    return readSection(storage, manual, fallback)
  }

  function setActiveSection(sectionId) {
    writeSection(storage, manual, sectionId)
  }

  function isPinned() {
    return readBoolean(storage, storageKey(manual, "pinned"))
  }

  function setPinned(value) {
    writeBoolean(storage, storageKey(manual, "pinned"), value)
  }

  return { isOpen, setOpen, activeSection, setActiveSection, isPinned, setPinned }
}
